import src from "IMAGE";
export default { src, width: 37, height: 37, blurWidth: 0, blurHeight: 0};
